<template>
  <select v-model="selectedValue" v-on:change="emitValue">  
    <option v-for="l in list" :key="l" v-bind:value="l">{{l}}</option>
  </select>
</template>

<script>
export default {
  name: 'DistributorSelector',
  computed:{list : function(){return this.$distributors}},
  data () { return {selectedValue: undefined}},
  props: ['value'],

  created: function(){
    this.selectedValue = this.value;
  },
  methods: {
    emitValue: function(){
      this.$emit('input', this.selectedValue)
    }
  },
  watch:{
    value: function(){
      this.selectedValue = this.value;
    },
    // selectedValue: function(){
      
    // }
  }
}
</script>
